module.exports = __webpack_public_path__ + "img/tele.42c5f074.jpg";